// ----------------------------------------------------------------------------- //
//  Add custom class to any section entering the viewport
// ----------------------------------------------------------------------------- //
const observerOptions = {
	root: null,
	rootMargin: '0px',
	threshold: 0.2,
};

function observerCallback(entries) {
	entries.forEach( (e) => {
		if ( e.isIntersecting ) {
			e.target.classList.add('js-visible');
		} else {
			e.target.classList.remove('js-visible');
		}
	});
}

const observer = new IntersectionObserver( observerCallback, observerOptions );
const sections = document.querySelectorAll('section');

if ( sections.length ) {
	sections.forEach( (el) => observer.observe(el) );
}
